import messages from '../messages.json';

export const menuItemType = {
  mono: 'mono',
  other: 'other',
} as const;

export const globalMenuItems = [
  // ホーム
  {
    type: menuItemType.mono,
    iconName: 'Home',
    heading: messages.heading.home,
    link: '/',
  },
  // ユーザー管理
  {
    type: menuItemType.mono,
    iconName: 'User',
    heading: messages.heading.userManagement,
    link: '/users',
    details: [],
  },
  // グループ
  {
    type: menuItemType.mono,
    iconName: 'Group',
    heading: messages.heading.groupManagement,
    link: '/groups',
  },
  {
    type: menuItemType.other,
    iconName: 'Other',
    heading: messages.heading.others,
    link: '/other',
    isOpen: true,
    details: [
      { link: '/other/contact', text: messages.heading.inquiry },
      {
        link: import.meta.env.VITE_APP_PRIVACY_POLICY,
        text: messages.heading.privacyPolicy,
      },
    ],
  },
];
